const col = {
    actions: {id: "actions", label: "Acțiuni", numeric: true, sticky: true, width: "130px"},
    actions_medium: {id: "actions", label: "Acțiuni", numeric: true, sticky: true, width: "80px"},
    actions_small: {id: "actions", label: "Acțiuni", numeric: true, sticky: true, width: "50px"},
    work_plan_id: {id: "work_plan_id", label: "Id", numeric: true, sortable: true, width: "70px"},
    work_plan_id_hidden: {id: "work_plan_id", label: "Id", numeric: true, sortable: true, hidden: true, width: "70px"},
    id_hidden: {id: "id", label: "Id", numeric: true, hidden: true, width: "70px"},
    teacher_name: {id: "teacher_name", label: "Profesor", noWrap: true, sortable: true, width: "180px",},
    classroom_name: {id: "classroom_name", label: "Clasă", noWrap: true, sortable: true, width: "60px"},
    subject_name: {id: "subject_name", label: "Disciplină", sortable: true, width: "130px", noWrap: true,},
    grade_name: {id: "grade_name", label: "An", sortable: true, width: "40px", noWrap: true,},
    subcategory_name: {id: "subcategory_name", label: "Capitol", noWrap: true, sortable: true, width: "200px", tooltip: true, tooltipTextLength: 21},
    created_at: {id: "created_at", label: "Creat la", width: "80px"},

    student_name: {id: "student_name", label: "Elev", noWrap: true, sortable: true, width: "180px", tooltip: true,},
    subcategory_score: {id: "subcategory_score", label: "Nivel curent", disablePadding: false, sortable: true, noWrap: true,},
    next_level: {id: "next_level", label: "Nivel urmator", noWrap: true,},
    recommended_tests: {id: "recommended_tests_no", label: "Teste recomandate", numeric: true, disablePadding: false, sortable: true, width: "90px",},
    realized_tests: {id: "realized_tests_no", label: "Teste realizate", numeric: true, disablePadding: false, sortable: true, width: "90px",},
    remaining_tests: {id: "remaining_tests_no", label: "Teste rămase", numeric: true, width: "90px",},
    disabled_select: {id: "disableSelect", label: "disableSelect", hidden: true,},
}


// ── WORK PLANS ──────────────────────────────────────────
export const WORK_PLANS_PRINCIPAL = [
    col.teacher_name, col.classroom_name, col.subject_name, col.grade_name, col.subcategory_name, col.created_at, col.work_plan_id, col.actions_small,
];

export const WORK_PLANS_TEACHER = [
    col.classroom_name, col.subject_name, col.grade_name, col.subcategory_name, col.created_at, col.actions_small, col.work_plan_id_hidden,
];

// ── WORK PLAN ──────────────────────────────────────────
export const WORK_PLAN_PRINCIPAL = [
    col.id_hidden, col.student_name, col.subcategory_score, col.next_level, col.recommended_tests, col.realized_tests, col.remaining_tests,
];
export const WORK_PLAN_TEACHER = [
    col.disabled_select, col.id_hidden, col.student_name, col.subcategory_score, col.next_level, col.recommended_tests, col.realized_tests, col.remaining_tests, col.actions_medium,
];
export const WORK_PLAN_STUDENT = [
    col.classroom_name, col.subject_name, col.grade_name, col.subcategory_name, col.subcategory_score, col.next_level, col.recommended_tests, col.realized_tests, col.remaining_tests,
];

type ColumnMap = Record<string, any[] | undefined>;

const COLUMNS_MAP: ColumnMap = {
    "teacher_work_plans": WORK_PLANS_TEACHER,
    "principal_work_plans": WORK_PLANS_PRINCIPAL,

    "principal": WORK_PLAN_PRINCIPAL,
    "teacher": WORK_PLAN_TEACHER,
    "student": WORK_PLAN_STUDENT,
}

export function getTableColumns(
    position: string,
    pageType: string,
): any[] {
    const typeGroup = pageType === "workPlans" ? "_work_plans" : "";
    const key = `${position}${typeGroup}`;

    return COLUMNS_MAP[key] ?? [];
}
